<template><div><h2 id="illustrations" tabindex="-1" class="d-docsite--header-2">Illustrations <a class="header-anchor d-link d-docsite--link d-link" href="#illustrations" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Illustrations are the slightly grown up version of icons with a little more detail. A illustration is an image that typically works in tandem with inline text to communicate a state in a more friendly way. They’re most often used in empty states, onboarding, and in-product announcements.</p>
<icons illustration kind="spot" size="large" :excluded-icons="excludedIllustrations"></icons></div></template>


<script setup>
// Temporarily exclude illustrations from being shown on the docsite
const excludedIllustrations = [
  'mind',
  'blank-space',
  'vector-vortex',
  'atomic-pathway',
  'black-hole',
  'orbital-harmony',
];
</script>